module.exports = __webpack_public_path__ + "static/media/form3.a3b13a1d.pdf";